export default "__VITE_ASSET__Dk0z74Kt__"